import * as globalBehaviors from '@cian/global-behaviors/browser';
import * as httpApi from '@cian/http-api/browser';
import * as telemetry from '@cian/telemetry/browser';
import * as web from '@cian/web/browser';

export function setupDependencies() {
  telemetry.setup();
  httpApi.setup({});
}

export function initDependencies() {
  telemetry.init();
  httpApi.init();
  web.init();
  globalBehaviors.init();
}
